import { ColorEnum } from '@/constants/color'
import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import { Container, TextSize } from '@/features/common/components/Overview/parts/ProductItem/types'
import PackageIcon from '@/features/ui/icons/components/PackageIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface ContainerListProps {
    containers: Container[]
    textSize: TextSize
}

const ContainerList: FC<ContainerListProps> = ({ containers, textSize }) => {
    const { t } = useTranslation()

    return (
        <View style={styles.containers}>
            <View style={styles.containersHeading}>
                <PackageIcon width={16} height={16} fill={ColorEnum.BLUE_500} />
                <Typography.Description
                    size={textSize}
                    font="regular"
                    style={styles.containersHeadingText}
                >
                    {t('common.overview.containers')}
                </Typography.Description>
            </View>
            {containers.map((container) => (
                <View key={container.id} style={styles.containerRow}>
                    <Typography.Description
                        size={textSize}
                        font="regular"
                        style={styles.containerName}
                    >
                        {container.name}
                    </Typography.Description>
                    <Typography.Description
                        size={textSize}
                        font="regular"
                        numberOfLines={1}
                        style={styles.containerPrice}
                    >
                        {container.price}
                    </Typography.Description>
                </View>
            ))}
        </View>
    )
}

export default ContainerList
